export * from "-!../vue-loader/lib/loaders/templateLoader.js??ref--5!../vue-loader/lib/index.js??vue-loader-options!./Home.vue?vue&type=template&id=69f8f38b"